import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import router from './router'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    idToken: null,
    userId: null,
    user: null,
    quotation: [],
    quotationIndex: [],
    loginError: {
      message: null
    },
    showModal: false,
    search: '',
    disable: false
  },
  mutations: {
    search (state, query) {
      state.search = query
    },
    show (state) {
      state.showModal = true
      state.loginError.message = ''
    },
    hide (state) {
      state.showModal = false
      state.loginError.message = ''
    },
    authUser (state, userData) {
      state.idToken = userData.token
      state.userId = userData.userId
    },
    // quote (state, items) {
    //   state.quoteItems = items
    // },
    quotation (state, items) {
      state.quotation.push(items)
      state.quotationIndex.push(items.title)
      // state.disable = true
      // localStorage.setItem('quotation', JSON.stringify(state.quotation))
    },
    removeItemQuotation (state, item) {
      state.quotation.splice(item, 1)
      state.quotationIndex.splice(item, 1)
      // state.disable = false
    },
    loginError (state, error) {
      state.loginError = error
    },
    storeUser (state, user) {
      state.user = user
    },
    clearAuthData (state) {
      state.idToken = null
      state.userId = null
      state.user = null
    }
  },
  actions: {
    search ({ commit, dispatch }, query) {
      commit('search', query)
    },
    quotationRequest ({ commit, dispatch }, items) {
      commit('quotation', items)
    },
    setLogoutTimer ({ commit }, expirationTime) {
      setTimeout(() => {
        commit('clearAuthData')
      }, expirationTime * 1000)
    },
    login ({ commit, dispatch }, authData) {
      axios.post('/auth/login/', {
        email: authData.email,
        password: authData.password,
        returnSecureToken: true
      })
        .then(res => {
          localStorage.setItem('token', res.data.token)
          localStorage.setItem('userId', res.data.userId)
          const remainingMilliseconds = 60 * 60 * 1000
          const expiryDate = new Date(new Date().getTime())
          localStorage.setItem('expiryDate', expiryDate.toISOString())
          commit('authUser', {
            token: res.data.token,
            userId: res.data.userId
          })
          commit('hide')
          // router.replace('/')
        })
        .catch(err => {
          commit('loginError', err.response.data)
        })
    },
    tryAutoLogin ({ commit }) {
        const token = localStorage.getItem('token')
        if (!token) {
          return
        }
        // const expirationDate = localStorage.getItem('expirationDate')
        // const now = new Date()
        // if (now >= expirationDate) {
        //   return
        // }
        const userId = localStorage.getItem('userId')
        commit('authUser', {
          token: token,
          userId: userId
        })
    },
    logout ({ commit }) {
      commit('clearAuthData')
      localStorage.removeItem('expiryDate')
      localStorage.removeItem('token')
      localStorage.removeItem('userId')
      router.replace('/')
    },
    fetchUser ({ commit, state }) {
        if (!state.idToken) {
          return
        }
        axios.get('/user/user/' + state.userId, { headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.getters.token
          }
        })
        .then(res => {
          commit('storeUser', res.data.user)
        })
        .catch(err => console.log(err))
    }
  },
  getters: {
    user (state) {
      return state.user
    },
    loginError (state) {
      return state.loginError
    },
    token (state) {
      return state.idToken
    },
    isAuthenticated (state) {
      return state.idToken !== null
    },
    quotationItems (state) {
      return state.quotation
    },
    showModal (state) {
      return state.showModal
    },
    search (state) {
      return state.search
    },
    restoreAddQBtn (state) {
      return state.disable
    },
    getQuotationIndex (state) {
      return state.quotationIndex
    }
  }
})
